<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-overlay :value="globalOverlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div v-if="loaded">
            <v-snackbar
                    v-model="snackbars['error'].enabled"
                    :color="'warning'"
                    :timeout="2000"
                    :top="true">
                {{snackbars['error'].text}}
            </v-snackbar>
            <v-snackbar
                    v-model="snackbars['message'].enabled"
                    :color="'primary'"
                    :timeout="2000"
                    :top="true">
                {{snackbars['message'].text}}
            </v-snackbar>
            <v-snackbar
                    v-model="incidentSnackbar.enabled"
                    color="red lighten-2"
                    :timeout="0"
                    :vertical="true">
                <v-layout align-center>
                    <v-icon class="pr-3" dark large>mdi-alert</v-icon>
                    <v-layout column>
                        <div>
                            <strong>Active Incident</strong>
                        </div>
                        <div>{{incidentSnackbar.text}}</div>
                        <div v-if="$permissionHolder.hasPermission('FIRST_ALERT.COMMUNICATIONS')"><a @click="openIncidentCommunications(incidentSnackbar.cadRequestId)">Goto Communications</a></div>
                    </v-layout>
                    <v-layout column>
                        <v-btn icon @click="incidentSnackbar.enabled = false" style="float:right">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-layout>
                </v-layout>

            </v-snackbar>
            <v-navigation-drawer
                    v-model="drawer"
                    id="main-drawer"
                    class="blue-grey lighten-5"
                    app>
                <v-list dense>
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title><router-link to="/" style="text-decoration:none">Home</router-link></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-group
                            no-action
                            sub-group
                            value="true"
                            v-if="$permissionHolder.hasPermission('USER')">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>Users</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item v-if="$permissionHolder.hasPermission('USER.CREATE')" ripple @click="go('CreateUser')">
                            <v-list-item-title >Create New User</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="$permissionHolder.hasPermission('USER')" ripple @click="go('Users')">
                            <v-list-item-title>Search Users</v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-group
                            no-action
                            sub-group
                            value="true"
                            v-if="$permissionHolder.hasPermission('ORGANIZATION')">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>Organizations</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item v-if="$permissionHolder.hasPermission('ORGANIZATION.CREATE')" ripple @click="go('CreateOrganization')">
                            <v-list-item-title>Create New Organization</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="$permissionHolder.hasPermission('ORGANIZATION')" ripple @click="go('Organizations')">
                            <v-list-item-title>Search Organizations</v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-group
                            no-action
                            sub-group
                            value="true"
                            >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>First Alert</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list>
					    <v-list-item @click="go('PremiseCommunications')" v-if="$permissionHolder.hasPermission('FIRST_ALERT.ANNOUNCE')">
						    <v-list-item-title>Premise Communications</v-list-item-title>
					    </v-list-item>
                        </v-list>
                    </v-list-group>

                    <v-list-group
                            no-action
                            sub-group
                            value="true"
                            v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>CAD Configurations</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item @click="go('CreateCadConfiguration')">
                            <v-list-item-title >Create New CAD Configuration</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="go('CadConfigurations')">
                            <v-list-item-title >Search CAD Configurations</v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                </v-list>
            </v-navigation-drawer>
            <v-app-bar app class="blue lighten-3" flat>
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title><router-link to="/" style="text-decoration:none">Caliber Public Safety</router-link></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-title style="font-size:75%">{{$userHolder.getUserName()}} / {{this.$userHolder.getPrimaryOrganizationName()}}</v-toolbar-title>
                <v-btn icon @click="gotoProfile()">
                    <v-icon>mdi-account-box</v-icon>
                </v-btn>
                <v-btn icon @click="logout()">
                    <v-icon>mdi-logout-variant</v-icon>
                </v-btn>
            </v-app-bar>
            <v-content>
                <router-view :key="$route.path"></router-view>
            </v-content>
            <v-footer app fixed class="blue lighten-3">
                <span>&copy;{{year}} -- Caliber Public Safety</span>
            </v-footer>
        </div>
        <v-dialog v-model="errorDialog" width="500">
            <v-card>
                <v-card-title>
                    Unable to Initialize Application
                </v-card-title>
                <v-card-text>
                    Sorry, the application could not initialize.  The server may not be responding
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="logout()">
                        Back to Login
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import api from '@/api';
    import {ORGANIZATION_INCIDENT_CREATED} from '@/events';
    export default {
        data() {
            return {
                loaded:false,
                incidentSubscriptionId : null,
                snackbars: {
                    'error':{'enabled':false,text:''},
                    'message':{'enabled':false,text:''}
                },
                drawer:true,
                year:  new Date().getFullYear(),
                globalOverlay : false,
                errorDialog : false,
                incidentSnackbar: {
                    text:null,
                    enabled:false,
                    cadRequestId: null
                },
                sound : null
            };
        },
        created() {
            this.sound = new Audio(require("../assets/ding.mp3"));
            this.globalOverlay = true;
            Promise.all([this.$permissionHolder.load(), this.$userHolder.load()]).then(() => {
                this.$socket.connect(() => {
                    this.loaded = true;
                    this.globalOverlay = false;

                    if (this.$permissionHolder.hasPermission('FIRST_ALERT.COMMUNICATIONS')) {
                        this.incidentSubscriptionId = this.$socket.subscribe(`/queue/organization/${this.$userHolder.getPrimaryOrganizationId()}/new-incident`, (message) => {
                            const incident = JSON.parse(message.body);
                            const text = `${incident.trackingNumber ? incident.trackingNumber : ''} A ${incident.eventText} Incident Has Been Reported At ${incident.premiseName}`;
                            this.incidentSnackbar.text = text;
                            this.incidentSnackbar.cadRequestId = incident.requestId;
                            this.incidentSnackbar.enabled = true;
                            this.sound.play();
                            this.$root.$emit(ORGANIZATION_INCIDENT_CREATED);

                        });
                    }
                });

            },function() {
                console.error("Could Not Initialize Web Socket");
            }).catch((error) => {
                this.errorDialog = true;
            });
            this.$root.$on('globalError',(message) => {
                this.snackbars['error'].text = message;
                this.snackbars['error'].enabled = true;
            });
            this.$root.$on('globalMessage',(message) => {
                this.snackbars['message'].text = message;
                this.snackbars['message'].enabled = true;
            });
            this.$root.$on('showGlobalOverlay',() => {
                this.globalOverlay = true;
            });
            this.$root.$on('hideGlobalOverlay',() => {
                this.globalOverlay = false;
            });
        },
        beforeDestroy() {
            if (this.incidentSubscriptionId) {
                this.$socket.unsubscribe(this.incidentSubscriptionId);
            }
            this.$socket.disconnect();
        },
        mounted() {

        },
        methods: {
            openIncidentCommunications(cadRequestId) {
                this.incidentSnackbar.enabled = false;
                this.$router.push({'path': `/incident/${cadRequestId}`});
            },
            go(id) {
                this.$router.push({name: id});
            },
            gotoProfile() {
                this.$router.push({path: '/user-profile'});
            },
            logout() {
                api.clearAuth();
                this.$router.replace("/login");
            }

        }
    };
</script>

<style>
    #main-drawer .v-list-item {
        padding-left : 20px !important;
    }
    #main-drawer .v-list-item__title {
        padding-left : 20px !important;
    }
</style>